import { DropdownItem } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import { noop } from 'lodash'
import React from 'react'

import { downloadAtendimentoInativo } from './downloadAtendimentoInativo'

interface AtendimentoInativoActionsProps {
  coUnicoAtendProf: string
  isRetificado: boolean
}

export function AtendimentoInativoActions(props: Readonly<AtendimentoInativoActionsProps>) {
  const { coUnicoAtendProf, isRetificado } = props
  return (
    <DropdownButton stopPropagationOnClick onKeyDown={(e) => e.stopPropagation()}>
      {/*TODO(RNG) #26114: Impressão dos registros inativos do atendimento retificado */}
      <DropdownItem onClick={isRetificado ? noop : () => downloadAtendimentoInativo(coUnicoAtendProf)}>
        Imprimir registro inativo
      </DropdownItem>
      {/*TODO(RNG) #24481: Auditoria */}
      <DropdownItem onClick={noop}>Imprimir auditoria do registro</DropdownItem>
    </DropdownButton>
  )
}
